import { FormikTextField, Section } from "components/disw";
import { DropDownBox } from "components/disw/DropDownBox";
import { FormikErrors } from "formik";
import React from "react";

import { makeStyles } from "@mui/styles";
import { ServiceProductCreatable } from "./types";

interface ServicesSectionProps {
  availableProductServices: string[];
  values: Partial<ServiceProductCreatable>;
  errors: FormikErrors<ServiceProductCreatable>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean
  ) => void;
  errorMessage?: string;
}

const useStyles = makeStyles(() => ({
  flex: { display: "flex", flexDirection: "column" },
  servicesInfo: {
    fontFamily: "Segoe UI",
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#6E6E6E",
    marginTop: 4
  }
}));

const ServicesSection: React.FC<ServicesSectionProps> = ({
  availableProductServices,
  values,
  errors,
  setFieldValue,
  errorMessage
}) => {
  const classes = useStyles();
  return (
    <Section name="Services">
      <div className={classes.flex}>
        <FormikTextField
          name="solutionKey"
          label="Solution"
          placeholder="Enter Solution Name"
          type="text"
          readOnly
          errorMessage={errorMessage}
          onChange={e => {
            setFieldValue("solutionKey", e.target.value);
          }}
        />
        <DropDownBox
          dataSource={availableProductServices}
          value={values.services ?? []}
          onValueChanged={(e: { value: string[] }) =>
            setFieldValue("services", e.value)
          }
          placeholder="Select Services (multiple possible)"
          label="Services"
          isError={Boolean(errors.services)}
          errorText={
            Array.isArray(errors.services)
              ? errors.services.join(", ")
              : errors.services
          }
        />
        <div className={classes.servicesInfo}>
          Only services for current solution are available
        </div>
      </div>
    </Section>
  );
};

export default ServicesSection;
